// extracted by mini-css-extract-plugin
module.exports = {"btn":"bootstrap_btn__29DHI"};